(() => {
  "use strict";

  angular
    .module("uwAgenda.global")
    .factory("TranscriptionService", [
      "$http",
      "$uibModal",
      TranscriptionServiceFn,
    ]);
  
  function TranscriptionServiceFn(
    $http,
    $uibModal
  ) {
    const baseUrl = "/api/transcriptions";
    const service = {
      search,
      setAsRead,
      clearTranscript,
      openTranscript,
      reopenTranscript,
      hasFoundTranscript
    };
    
    let vm = this;
    
    clearTranscript();

    return service;
    
    function search(agendaOwnerId, phoneNumber, allowRead, latestOnly, fromDate, toDate, page, itemsPerPage) {
      return $http({
        url: baseUrl,
        method: "GET",
        params: {
          agendaOwnerId: agendaOwnerId,
          phoneNumber: phoneNumber,
          allowRead: allowRead,
          latestOnly: latestOnly,
          fromDate: fromDate,
          toDate: toDate,
          page: page,
          itemsPerPage: itemsPerPage,
        },
      }).then(function (response) {
        return response.data;
      });
    }
    
    function setAsRead(id) {
      return $http.put(`${baseUrl}/${id}`, { isRead: true }).then(response => response.data);
    }
    
    function clearTranscript() {
      vm.transcript = undefined;
      vm.foundTranscript = false;
    }

    function openTranscript(agendaOwnerId, phoneNumber) {
      // don't try to fetch it if there is no phone number
      if (!phoneNumber) {
        return;
      }

      // don't fetch it again as we already have it
      if (vm.foundTranscript) {
        return showModal();
      }

      // get the last transcription within the last hour
      const minutes = 60;
      const now = new Date();
      now.setTime(now.getTime() - (minutes * 60 * 1000));

      return search(
        agendaOwnerId,
        phoneNumber,
        false,
        true,
        now,
        null,
        1,
        1).then(result => {
        if (result.results.length > 0) {
          vm.foundTranscript = true;
          vm.transcript = result.results[0];

          setAsRead(vm.transcript.id);

          return showModal();
        } else {
          vm.foundTranscript = false;
        }
      });
    }

    function reopenTranscript() { 
      if (vm.foundTranscript) {
        return showModal();
      }
    }
    
    function hasFoundTranscript() { return vm.foundTranscript; }
    
    function showModal() {
      return $uibModal.open({
          backdrop: "static",
          keyboard: false,
          animation: true,
          templateUrl: "/app/global/templates/transcript-modal.template.html",
          controller: "TranscriptController",
          controllerAs: "viewModel",
          size: "md",
          resolve: {
            transcript: () => vm.transcript
          }
        })
        .result
        .then(() => { }, () => {});
    }
  }
})();
